import { Const_UniqueKey, DefaultDBVersion } from '@nu-art/ts-common';
export const getModuleFEConfigV3 = (dbDef) => {
    return {
        key: dbDef.dbKey,
        versions: dbDef.versions || [DefaultDBVersion],
        validator: dbDef.modifiablePropsValidator,
        dbConfig: {
            version: dbDef.versions[0],
            name: dbDef.frontend.name,
            group: dbDef.frontend.group,
            indices: dbDef.indices,
            autoIncrement: false,
            uniqueKeys: dbDef.uniqueKeys || [Const_UniqueKey]
        },
    };
};
//# sourceMappingURL=db-def.js.map